export const STATUS_NO_CONTENT = 204;
export const STATUS_CREATED = 201;
export const STATUS_ACCEPTED = 202;
export const STATUS_RESET_CONTENT = 205;
export const STATUS_BAD_REQUEST = 400;

export const JSON_CONTENT_TYPE = 'application/json';
export const HEADER_CONTENT_TYPE = 'Content-Type';
export const HEADER_ACCEPT = 'Accept';
export const HEADER_CSRF_TOKEN = 'X-Csrf-Token';
export const HEADER_CSRF_TOKEN_RETRY = 'X-Csrf-Token-Retry';
